/** @plugin */
import { gettext } from "@nextgisweb/pyramid/i18n";
import { panelRegistry } from "@nextgisweb/webmap/panel/registry";
import type { DisplayConfig } from "@nextgisweb/webmap/type/api";

import PkkIcon from "@nextgisweb/cadaster/icon/pkk";

panelRegistry(COMP_ID, {
    widget: () => import("../panel/CadasterPanel"),
    store: () => import("../panel/CadasterStore"),
    name: "cadaster",
    title: gettext("Cadaster services"),
    icon: <PkkIcon />,
    order: 50,
    applyToTinyMap: true,

    isEnabled: ({ config }: { config: DisplayConfig }) => {
        const isCadasterPluginEnabled =
            config.webmapPlugin &&
            Object.keys(config.webmapPlugin).includes(
                "@nextgisweb/cadaster/webmap/plugin"
            );
        return isCadasterPluginEnabled;
    },
});
